import { openErrorDialog, } from 'console/dialogs/error/redux/actions';
import { selectNullableSelectedDeviceId } from 'entities/device/lib';
export const createHistoryMaintenance = (device_id, maintenance) => async (dispatch, getState, { api }) => {
    try {
        dispatch({
            type: 'ADD_HISTORY_MAINTENANCE',
            device_id,
            maintenance,
        });
        await api.add_history_maintenance(device_id, maintenance);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error,
            error_ui: 'Не удалось добавить запись в историю обслуживания',
        }));
    }
};
export const deleteHistoryMaintenance = (device_id, maintenance_id) => async (dispatch, getState, { api }) => {
    try {
        dispatch({
            type: 'DELETE_HISTORY_MAINTENANCE',
            device_id,
            maintenance_id,
        });
        await api.delete_history_maintenance(device_id, maintenance_id);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error,
            error_ui: 'Не удалось удалить запись из истории обслуживания',
        }));
    }
};
export const editHistoryMaintenance = (device_id, maintenance) => async (dispatch, getState, { api }) => {
    try {
        dispatch({
            type: 'EDIT_HISTORY_MAINTENANCE',
            device_id,
            maintenance,
        });
        await api.edit_history_maintenance(device_id, maintenance);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error,
            error_ui: 'Не удалось отредактировать запись в истории обслуживания',
        }));
    }
};
export const select_maintenance_attachment_action = (file) => ({
    type: 'SELECT_MAINTENANCE_ATTACHMENT',
    file,
});
export const is_loading_upload_maintenance_attachment_action = (is_loading) => ({ type: 'IS_LOADING_UPLOAD_MAINTENANCE_ATTACHMENT', is_loading });
export const set_maintenance_attachment_ids = (ids, filenames) => ({ type: 'SET_MAINTENANCE_ATTACHMENT_IDS', ids, filenames });
export const maintenance_attachment_set_message_action = (content) => ({ type: 'MAINTENANCE_ATTACHMENT_SET_MESSAGE', content });
export const upload_maintenance_attachment_action = (files) => async (dispatch, getState, { api }) => {
    const device_id = selectNullableSelectedDeviceId(getState());
    if (device_id == null)
        return;
    if (!FormData) {
        dispatch(maintenance_attachment_set_message_action({
            title: 'Неподдерживаемый браузер',
            message: 'Загрузка файлов не поддерживается в вашем браузере. Воспользуйтесь Chrome, Firefox, Opera 12+ или Internet Explorer 10+',
        }));
        return;
    }
    if (files == null || files.length === 0) {
        dispatch(maintenance_attachment_set_message_action({
            title: 'Нет файла для загрузки',
            message: 'Выберите файл для загрузки',
        }));
        return;
    }
    try {
        dispatch(is_loading_upload_maintenance_attachment_action(true));
        const response = await api.upload_maintenance_attachment(device_id, files);
        const filenames = files.map((file_info) => file_info.name);
        dispatch(set_maintenance_attachment_ids(response.attachment_ids, filenames));
    }
    catch (error) {
        const { json } = error;
        dispatch(maintenance_attachment_set_message_action({
            title: 'Загрузка файлов не удалась',
            message: json?.error_ui ?? 'Ошибка связи с сервером',
        }));
    }
    finally {
        dispatch(is_loading_upload_maintenance_attachment_action(false));
    }
};
export const maintenance_attachment_reset_upload_action = () => ({ type: 'RESET_UPLOAD_MAINTENANCE_ATTACHMENT' });
